module.exports = __webpack_public_path__ + "assets/63659dc92101996f2b4153239c245db9.png";